import { environment } from '../../environments/environment';
import type { CompanySearchApiResult } from './fetchCompanySearchResults';

/**
 * Every descendant of a company, flattened — the mapper walks the tree itself
 * (depth-capped at 25) and returns one request's worth of rows. The rows carry
 * no parent link, so this answers "how many companies" but not "whose child".
 */
export const fetchAllCompanySubsidiaries = async (
  rcid: number,
  signal?: AbortSignal
): Promise<CompanySearchApiResult[]> => {
  const response = await fetch(
    `${environment.COMPANY_MAPPER_URL}/all-subsidiaries`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ rcid }),
      signal,
    }
  );

  if (!response.ok) {
    throw new Error(`all-subsidiaries failed: ${response.status}`);
  }

  return response.json();
};
